import {objectFromEntries} from '@benchling/js-utils';
import {useMemo} from 'react';

import BenchlingConfig from 'BenchlingConfig';

interface SampleTestPlanWithPublishedProcedureFlowchartVersion {
  procedureId: string;
  publishedProcedureFlowchartVersionId: string;
}

export function usePublishedProcedureFlowchartVersionIdsByProcedureId(
  sampleTestPlans: Array<{
    procedureId: string;
    publishedProcedureFlowchartVersionId: string | null;
  }>
): Record<string, string> {
  return useMemo(() => {
    if (!BenchlingConfig.PROCEDURES_ENABLE_PUBLISHING) {
      return {};
    }

    return objectFromEntries(
      sampleTestPlans
        .filter(
          (sampleTestPlan): sampleTestPlan is SampleTestPlanWithPublishedProcedureFlowchartVersion =>
            sampleTestPlan.publishedProcedureFlowchartVersionId != null
        )
        .map((sampleTestPlan) => [
          sampleTestPlan.procedureId,
          sampleTestPlan.publishedProcedureFlowchartVersionId,
        ])
    );
  }, [sampleTestPlans]);
}
